import { useAsyncFn } from 'react-use-v13';

import {
  FileLanguageType,
  LANGUAGE_OPTIONS as SUPPORTED_EXECUTION_LANGUAGES,
} from '@scale/shared/sphereEngine/types';
import { ICustomCodeEnvironment } from '@scale/shared/types/config';

import { executeCodeSubmission } from '../coding/helpers';

export function isSupportedCodeRunLanguage(language: string): language is FileLanguageType {
  return SUPPORTED_EXECUTION_LANGUAGES.some(({ id }) => id === (language as FileLanguageType));
}

export function useRunCodeExecution({
  language,
  code,
  assignmentId = 'assignmentId',
  customCodeEnvironment,
}: {
  language: string;
  code: string;
  assignmentId?: string;
  customCodeEnvironment?: ICustomCodeEnvironment;
}) {
  return useAsyncFn(async () => {
    if (isSupportedCodeRunLanguage(language)) {
      try {
        return await executeCodeSubmission(
          code,
          language,
          undefined,
          assignmentId,
          customCodeEnvironment,
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return {
          success: false,
          stderr: e?.message ?? 'Error',
          stdout: '',
        };
      }
    } else {
      return {
        success: false,
        stderr: 'Language not supported',
        stdout: '',
      };
    }
  }, [language, code]);
}
